import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      flex: 1,
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start',
      borderRadius: theme.shape.borderRadius,

      '& > div': {
        height: '100%',
        display: 'flex',
        flex: 1,
        alignItems: 'stretch',
        flexDirection: 'column',
        justifyContent: 'start',
        overflowY: 'auto',
        overflowX: 'hidden',
        backgroundColor: 'white',
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(2, 4, 2, 2),
      },
    },
    editable: {
      flex: 1,
      minHeight: (props) =>
        props.noMinMaxHeight
          ? 'none !important'
          : props.shortExpanding
          ? '80px !important'
          : props.footerShown && props.promptImage
          ? '178px !important'
          : props.footerShown
          ? '210px !important'
          : '250px !important', //overrides styles of slate in case of placeholder
      maxHeight: (props) =>
        props.noMinMaxHeight || props.shortExpanding ? 'none !important' : '350px !important', //overrides styles of slate in case of placeholder
    },
    disabled: {
      '& $editable': {
        backgroundColor: COLORS.gray.gray80,
        color: COLORS.gray.gray40,
      },
    },
  }),
  { name: 'InstructionsTextarea' }
);
